interface Props {
  eyebrow: string;
  title: string;
  desc?: string;
  center?: boolean;
}

export default function SectionHeader({ eyebrow, title, desc, center }: Props) {
  return (
    <div className={`mb-8 md:mb-10 ${center ? "text-center mx-auto" : ""}`}>
      <div
        className={`inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold uppercase tracking-wider ${
          center ? "mx-auto" : ""
        }`}
      >
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary-500"></span>
        {eyebrow}
      </div>
      <h2 className="mt-3 font-heading font-extrabold text-foreground-950 text-2xl md:text-4xl tracking-tight">
        {title}
      </h2>
      {desc && <p className={`mt-3 max-w-2xl text-foreground-600 text-sm md:text-base leading-relaxed ${center ? "mx-auto" : ""}`}>{desc}</p>}
    </div>
  );
}